import { Logger } from 'data/common';

function debug(eventName, params) {
    Logger.debug(`Fhe : <---------- Event Received ${eventName}`, params);
}

function bindSettingsEvents(BoxInstance) {
    BoxInstance.socketOn('boxinfos', function(args) {
        const { mactarget: macAddress, time_diff: timeDiff, dns_resolv: dnsResolv, free_space: freeSpace, zway_status: zwaveStatus, version } = args;
        debug('boxinfos', args);

        if (
            macAddress === undefined ||
            timeDiff === undefined ||
            dnsResolv === undefined ||
            freeSpace === undefined ||
            zwaveStatus === undefined ||
            version === undefined
        )
            return Logger.error(`Arguments manquants sur l'event socket boxinfos : "${args}"`);
        if (!BoxInstance.getState().environments.fhe.data.Boxes.hasIn(['list', macAddress]))
            return Logger.debug(`Le FHE-Center "${macAddress}" n'est pas présent dans le store`);

        let boxSysInfo = {
            timeDiff,
            dnsResolv,
            freeSpace: parseInt(freeSpace),
            firmwareVersion: version,
            zwaveStatus
        };

        BoxInstance.dispatch({
            type: `FHE__UPDATE_BOX_SYS_INFO`,
            macAddress,
            boxSysInfo
        });
    });

    BoxInstance.socketOn('vpnConnected', function(args) {
        const { mac: macAddress, ip: ipAddress } = args;
        debug('vpnConnected', args);

        if (macAddress === undefined || ipAddress === undefined)
            return Logger.error(`Arguments manquants sur l'envent socket vpnConnected : "${args}"`);
        if (!BoxInstance.getState().environments.fhe.data.Boxes.hasIn(['list', macAddress]))
            return Logger.debug(`Le Fhe-Center "${macAddress}" n'est pas présent dans le store`);
        BoxInstance.dispatch({
            type: `FHE__UPDATE_BOX_IP`,
            macAddress,
            ipAddress
        });
    });

    BoxInstance.socketOn('vpnDisconnected', function(args) {
        const { mac: macAddress } = args;
        debug('vpnDisconnected', args);

        if (macAddress === undefined) return Logger.error(`Arguments manquants sur l'envent socket vpnDisconnected : "${args}"`);
        if (!BoxInstance.getState().environments.fhe.data.Boxes.hasIn(['list', macAddress]))
            return Logger.debug(`Le Fhe-Center "${macAddress}" n'est pas présent dans le store`);
        BoxInstance.dispatch({
            type: `FHE__UPDATE_BOX_IP`,
            macAddress,
            ipAddress: null
        });
    });

    BoxInstance.socketOn('boxConnected', function(args) {
        const { mac: macAddress } = args;
        debug('boxConnected', args);

        if (macAddress === undefined) return Logger.error(`Arguments manquants sur l'envent socket boxConnected : "${args}"`);
        if (!BoxInstance.getState().environments.fhe.data.Boxes.hasIn(['list', macAddress]))
            return Logger.debug(`Le FHE-Center "${macAddress}" n'est pas présent dans le store`);

        BoxInstance.dispatch({
            type: `FHE__UPDATE_BOX_STATUS`,
            macAddress,
            boxIsConnected: 1
        });

        BoxInstance.emit(`boxStatusChange${macAddress}`, 1);
    });
    BoxInstance.socketOn('boxDisconnected', function(args) {
        const { mac: macAddress } = args;
        debug('boxDisconnected', args);

        if (macAddress === undefined) return Logger.error(`Arguments manquants sur l'envent socket boxDisconnected : "${args}"`);
        if (!BoxInstance.getState().environments.fhe.data.Boxes.hasIn(['list', macAddress]))
            return Logger.debug(`Le FHE-Center "${macAddress}" n'est pas présent dans le store`);

        BoxInstance.dispatch({
            type: `FHE__UPDATE_BOX_STATUS`,
            macAddress,
            boxIsConnected: 0
        });

        BoxInstance.emit(`boxStatusChange${macAddress}`, 0);
    });
    BoxInstance.socketOn('enableZway', function(args) {
        const { box_mac, res } = args;
        debug('zwayEnabled', args);

        if (box_mac && res === 'success') {
            BoxInstance.dispatch({
                type: 'FHE__UPDATE_ZWAVE_STATUS',
                macAddress: box_mac,
                status: 'ok'
            });
        }
    });
    BoxInstance.socketOn('disableZway', function(args) {
        const { box_mac, res } = args;
        debug('zwayDisabled', args);

        if (box_mac && res === 'success') {
            BoxInstance.dispatch({
                type: 'FHE__UPDATE_ZWAVE_STATUS',
                macAddress: box_mac,
                status: 'ko'
            });
        }
    });
}

export default function initBinds(BoxInstance) {
    bindSettingsEvents(BoxInstance);
}



// WEBPACK FOOTER //
// ./environments/fhe/eventsSocket/Box/binds.js